import { matchPath, useLocation } from 'react-router';

function useRouteMatch(patterns: readonly string[]) {
  const { pathname, search } = useLocation();
  const exactMatch = patterns.find((pattern) => {
    return pattern === pathname || pattern === `${pathname}${search}`;
  });
  if (exactMatch) return exactMatch;

  // Sort patterns by length (descending) to match most specific first
  const sortedPatterns = patterns.toSorted((a, b) => b.length - a.length);
  return sortedPatterns.find((pattern) => {
    return matchPath(pattern, pathname) || pathname.startsWith(pattern);
  });
}

export default useRouteMatch;
